import { memo, useCallback } from 'react';
import { CardData } from '../../../../../types';
import { InputField } from './InputField';
import { CheckboxField } from './CheckboxField';

interface LinkSectionProps {
    cardNum: 1 | 2;
    data: CardData;
    disabled: boolean;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: any) => void;
}

export const LinkSection = memo(({
    cardNum,
    data,
    disabled,
    onChange,
}: LinkSectionProps) => {
    const handleNewTabChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(cardNum, 'openInNewTab', e.target.checked);
    }, [onChange, cardNum]);

    return (
        <div className="card-config-full-width">
            <div className="input-group-row">
                <div className="input-wrapper-full">
                    <InputField
                        cardNum={cardNum}
                        idSuffix="link"
                        label="Link URL"
                        field="link"
                        value={data.link}
                        placeholder="Enter the associated URL here."
                        disabled={disabled}
                        onChange={onChange}
                    />
                </div>
                <CheckboxField
                    id={`newtab-${cardNum}`}
                    label="New Tab"
                    checked={data.openInNewTab}
                    onChange={handleNewTabChange}
                    disabled={disabled}
                />
            </div>
        </div>
    );
});
